import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { useTouchFeedback } from "@/lib/useTouchFeedback";

// Scrolls to top on route change.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
};

export const Layout = ({ children }) => {
  const root = useRef(null);
  useTouchFeedback(root);
  return (
    <div ref={root} className="min-h-screen flex flex-col bg-background">
      <ScrollToTop />
      <Header />
      <main id="main-content" tabIndex={-1} className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
